export const META_PIXEL_ID = '1047173294591994'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
    __metaPixelReady?: boolean
  }
}

/** Injects Meta's official base code exactly once. */
function loadPixel(): void {
  if (window.fbq) return

  /* eslint-disable */
  const n: any = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  /* eslint-enable */

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

/** Loads the pixel, initializes it and fires PageView + ViewContent. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.__metaPixelReady) return

  loadPixel()
  window.__metaPixelReady = true

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
  window.fbq('track', 'ViewContent', {
    content_name: 'Anfitrión Pro 365',
    content_type: 'product',
    content_ids: ['anfitrion-pro-365'],
    value: 19,
    currency: 'USD',
  })
}

/** Fires a standard Meta event, initializing the pixel first if needed. */
export function trackMetaEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  if (!window.__metaPixelReady) initMetaPixel()
  window.fbq?.('track', event, params)
}
